import React from 'react';
import { CtaButton } from './CtaButton';
import { IMAGES, PRICE_LABEL, TOTAL_VALUE, offerItems } from '../data/offer';
export function OfferStack() {
  const [main, ...bonuses] = offerItems;
  return <section id="oferta" className="w-full bg-white" data-id="element-77" data-mp="2pvet189zd5kh">
      <div className="mx-auto max-w-6xl px-4 py-16 sm:px-6 sm:py-24" data-id="element-78" data-mp="2pt2aou0b8t6w">
        <div className="max-w-2xl" data-id="element-79" data-mp="2kxd6ueh9cq4s">
          <p className="font-display text-sm font-bold uppercase tracking-widest text-lime-600" data-id="element-80" data-mp="2ku90bagbliay">
            Presentamos
          </p>
          <h2 className="mt-2 font-display text-3xl font-extrabold leading-tight tracking-tight text-navy-950 sm:text-5xl" data-id="element-81" data-mp="1t5p0q9p2ozue">
            Dominio del Pickleball:
            <br data-id="element-82" data-mp="26y59zs8khu3r" />
            El Manual Táctico
          </h2>
          <p className="mt-4 text-lg text-navy-800/80" data-id="element-83" data-mp="224snbnng7xdn">
            El pack completo para transformar tu juego hoy mismo.
          </p>
        </div>

        <div className="mt-12 grid gap-8 lg:grid-cols-[1.25fr_1fr] lg:gap-14" data-id="element-84" data-mp="19gwtqrt6ell3">
          <div data-id="element-85" data-mp="19f2g7yk8hvr1">
            <article className="overflow-hidden rounded-2xl border-2 border-navy-950 bg-navy-950 text-white" data-id="element-86" data-mp="14p3f63f4lzno">
              <img src={IMAGES.cheatsheet} alt="Diagrama táctico abierto en un celular al costado de la cancha" className="h-56 w-full object-cover sm:h-64" data-id="element-87" data-mp="19nmzjze2n3dx" />
              <div className="p-6 sm:p-8" data-id="element-88" data-mp="1jcy4raxu7nwj">
                <p className="font-display text-xs font-bold uppercase tracking-widest text-lime-400" data-id="element-89" data-mp="1jg2esoxzhdv4">
                  {main.label} · 60 páginas
                </p>
                <h3 className="mt-2 font-display text-2xl font-extrabold tracking-tight sm:text-3xl" data-id="element-90" data-mp="qq3pcsfvnepx">
                  {main.title}
                </h3>
                <p className="mt-3 leading-relaxed text-white/80" data-id="element-91" data-mp="zpqqdd4p2iig">{main.description}</p>
                <p className="mt-5 font-display text-sm font-bold text-white/60" data-id="element-92" data-mp="znntqa91dr4r">
                  Valor: US$ {main.value}
                </p>
              </div>
            </article>

            <ul className="mt-6 grid gap-4 sm:grid-cols-3" data-id="element-93" data-mp="2b78kdkwh43rs">
              {bonuses.map(bonus => <li key={bonus.title} className="flex h-full flex-col rounded-xl border border-navy-200 bg-sand p-5" data-id="element-94" data-mp="c2i7v5vnzqqk">
                  <p className="font-display text-xs font-bold uppercase tracking-widest text-lime-600" data-id="element-95" data-mp="l0k7pi3nwdc9">
                    {bonus.label}
                  </p>
                  <h4 className="mt-1.5 font-display text-lg font-bold leading-snug tracking-tight text-navy-950" data-id="element-96" data-mp="3ohav9avaf91p">
                    {bonus.title}
                  </h4>
                  <p className="mt-2 text-sm leading-relaxed text-navy-800/80" data-id="element-97" data-mp="3kee611b8seos">
                    {bonus.description}
                  </p>
                  <p className="mt-auto pt-4 font-display text-sm font-bold text-navy-600" data-id="element-98" data-mp="3tfuh7b9vsku2">
                    Valor: US$ {bonus.value}
                  </p>
                </li>)}
            </ul>
          </div>

          <div className="lg:sticky lg:top-28 lg:self-start" data-id="element-99" data-mp="30roskdfpiboy">
            <div className="rounded-2xl border border-navy-200 bg-white p-6 shadow-card sm:p-8" data-id="element-100" data-mp="1g9xj5e9pk3q7">
              <h3 className="font-display text-lg font-extrabold uppercase tracking-wide text-navy-950" data-id="element-101" data-mp="1l15u4eqorx5h">
                Tu acceso completo
              </h3>
              <dl className="mt-5 space-y-2.5 border-b border-navy-200 pb-5 text-sm" data-id="element-102" data-mp="177o9srq6egee">
                {offerItems.map(item => <div key={item.title} className="flex items-baseline justify-between gap-4" data-id="element-103" data-mp="1zxn6986p9ft3">
                    <dt className="text-navy-800/80" data-id="element-104" data-mp="240a1lj2kxiv1">{item.title}</dt>
                    <dd className="shrink-0 font-medium tabular-nums text-navy-600 line-through" data-id="element-105" data-mp="23xfhjsnha025">
                      US$ {item.value}
                    </dd>
                  </div>)}
              </dl>
              <div className="flex items-baseline justify-between gap-4 py-4 text-sm" data-id="element-106" data-mp="el3hnp1vm09s">
                <span className="font-display font-bold uppercase tracking-wide text-navy-950" data-id="element-107" data-mp="jjx07vw0shgt">
                  Valor total
                </span>
                <span className="font-display text-lg font-bold tabular-nums text-navy-600 line-through" data-id="element-108" data-mp="yud40lstztm0">
                  US$ {TOTAL_VALUE}
                </span>
              </div>
              <div className="rounded-xl bg-navy-950 p-5 text-white" data-id="element-109" data-mp="q0gin97hql7n">
                <p className="text-xs font-semibold uppercase tracking-widest text-lime-400" data-id="element-110" data-mp="l2f2ox5d320e">
                  Precio de hoy
                </p>
                <p className="mt-1 font-display text-5xl font-extrabold tracking-tight" data-id="element-111" data-mp="1hr4hufpltgio">
                  {PRICE_LABEL}
                </p>
                <p className="mt-1 text-sm text-white/60" data-id="element-112" data-mp="18rr9jqd7uxzj">
                  Pesos argentinos (ARS). Pago único.
                </p>
              </div>
              <div className="mt-5" data-id="element-113" data-mp="13rv3llkykwhc">
                <CtaButton size="lg" full location="panel-oferta" data-id="element-114" data-mp="13v0tv45bq4en">
                  Comprar ahora
                </CtaButton>
              </div>
              <p className="mt-3 text-center text-xs text-navy-600" data-id="element-115" data-mp="3oim38ushcj4y">
                Pago único · Acceso inmediato · Garantía de 7 días
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}